export default __webpack_public_path__ + "img/ic-qantas.1552c13d.png";